import React from "react"
import { graphql } from "gatsby"
import Layout from "../../components/layout"

const IndexPage = ({ data }) => {
  const imgData = data.fileName.childImageSharp.fluid
  const author = "jhope"
  const quote = `You gvae to me unconditionally. You were my support. You can lean on me now. I am always by your side.`

  return <Layout imgData={imgData} author={author} quote={quote} />
}

export default IndexPage

export const query = graphql`
  query {
    fileName: file(relativePath: { eq: "jhope4.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
